module.exports = __webpack_public_path__ + "img/Twitter.24a4a653.svg";